import { api } from "./axios";
import { axiosApp } from "./axiosApp";

export const fetchAllConversationApi = async (params) => {
    try {
        const res = await axiosApp.get('/conversation?clientId=' + params.clientId);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error;
    }
}

export const createConversationApi = async (conversationData) => {
    try {
        const res = await axiosApp.post('/conversation/create', conversationData);
        return res.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const updateConversationApi = async (conversationId, updateData) => {
    try {
        const res = await axiosApp.put(`/conversation/${conversationId}`, updateData);
        return res.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const deleteConversationApi = async (conversationId) => {
    try {
        const res = await axiosApp.delete(`/conversation/${conversationId}`);
        return res.data;
    } catch (error) {
        throw error.response.data ? error.response.data : error;
    }
}

export const generateChatTitleApi = async (conversationId) => {
    try {
        const res = await axiosApp.post(`/conversation/${conversationId}/generate-title`);
        return res.data;
    } catch (error) {
        throw error.response?.data || error;
    }
}

